import { render } from "./AllFileMove.vue?vue&type=template&id=1c1bbe0a"
import script from "./AllFileMove.vue?vue&type=script&lang=js"
export * from "./AllFileMove.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__